export const Colors = {
  darkGreen100: 'rgba(31, 57, 48, 1)',
  black100: 'rgba(0, 0, 0, 1)',
  black90: 'rgba(0, 0, 0, 0.9)',
  black80: 'rgba(0, 0, 0, 0.8)',
  black70: 'rgba(0, 0, 0, 0.7)',
  black60: 'rgba(0, 0, 0, 0.6)',
  black50: 'rgba(0, 0, 0, 0.5)',
  black40: 'rgba(0, 0, 0, 0.4)',
  black30: 'rgba(0, 0, 0, 0.3)',
  black20: 'rgba(0, 0, 0, 0.2)',
  black10: 'rgba(0, 0, 0, 0.1)',
  light100: 'rgba(255,255,255, 1)',
  light90: 'rgba(255,255,255, 0.9)',
  light80: 'rgba(255,255,255, 0.8)',
  light70: 'rgba(255,255,255, 0.7)',
  light60: 'rgba(255,255,255, 0.6)',
  light50: 'rgba(255,255,255, 0.5)',
  light40: 'rgba(255,255,255, 0.4)',
  light30: 'rgba(255,255,255, 0.3)',
  light20: 'rgba(255,255,255, 0.2)',
  light10: 'rgba(255,255,255, 0.1)',
  grey100: 'rgba(240, 238, 236, 1)',
  grey200: 'rgba(243, 234, 225, 1)',
  grey300: 'rgba(253, 251, 249, 0.40)',
  white000: '#ffffff',
  white10: '#FDFBF9',
  green10: '#1F3930',
  red10: '#EB2027',
  gold10: '#C0A46F',
  lightGreen: '#BCCD48',
  darkGreen: '#1F3930',
  grey90: '#F3F1EF',
};
